module.exports = __webpack_public_path__ + "static/img/pic_dzzcxh.3acdcde6.png";